/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: { borderColor: '#efefef', borderWidth: 3 }
    },
    {
      if: { focus: true },
      tokens: {
        outerBorderColor: '#000000',
        outerBorderGap: 2,
        outerBorderWidth: 2
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#efefef',
        borderColor: 'transparent',
        outerBorderColor: '#000000'
      }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#efefef',
    borderRadius: 8,
    borderWidth: 1,
    flex: 1,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 0,
    outerBorderWidth: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    separatorColor: '#000000'
  }
}
export default theme
